<div class="fundo" *ngIf="aberto" (click)="fechar.emit()"></div>
<aside class="painel" [class.aberto]="aberto" role="dialog" aria-label="Regras da classificação" [attr.aria-hidden]="!aberto">
  <header class="painel-topo">
    <div>
      <h3>Regras da classificação</h3>
      <p>{{ origem }}</p>
    </div>
    <button type="button" class="fechar" (click)="fechar.emit()" aria-label="Fechar"><i class="fe-x"></i></button>
  </header>

  <div class="painel-corpo">
    <p class="intro">Os clientes mudam de segmento sozinhos a cada pedido e toda madrugada. Ajuste os números e veja a regra de cada segmento mudar ao lado.</p>

    <div class="grupo">
      <div class="grupo-titulo">Frequência e valor · últimos 90 dias</div>
      <label class="campo">
        <span class="rotulo">Pedidos para frequência alta</span>
        <span class="entrada" [class.invalido]="errosPorCampo.fAlta"><input type="number" min="4" step="1" [(ngModel)]="form.fAlta" name="fAlta"><em>pedidos</em></span>
          <span class="erro-campo" *ngIf="errosPorCampo.fAlta">{{ errosPorCampo.fAlta }}</span>
        <span class="dica">Quantos pedidos em 90 dias um Campeão precisa ter.</span>
      </label>
      <div class="dupla">
        <label class="campo">
          <span class="rotulo">Ticket médio</span>
          <span class="entrada" [class.invalido]="errosPorCampo.vMedio"><em class="pre">R$</em><input type="number" min="1" step="1" [(ngModel)]="form.vMedio" name="vMedio"></span>
          <span class="erro-campo" *ngIf="errosPorCampo.vMedio">{{ errosPorCampo.vMedio }}</span>
          <span class="dica">Abaixo disso, o ticket conta como baixo.</span>
        </label>
        <label class="campo">
          <span class="rotulo">Ticket alto</span>
          <span class="entrada" [class.invalido]="errosPorCampo.vAlto"><em class="pre">R$</em><input type="number" min="1" step="1" [(ngModel)]="form.vAlto" name="vAlto"></span>
          <span class="erro-campo" *ngIf="errosPorCampo.vAlto">{{ errosPorCampo.vAlto }}</span>
          <span class="dica">A partir disso, o cliente pode ser Campeão.</span>
        </label>
      </div>
      <button type="button" class="sugestao" (click)="useSugestao()" [disabled]="buscandoSugestao">
        <i [class]="buscandoSugestao ? 'fe-loader gira' : 'fe-zap'"></i>
        Usar o que a sua base mostra
      </button>
    </div>

    <div class="grupo">
      <div class="grupo-titulo">Tempo sem pedir</div>
      <div class="dupla">
        <label class="campo">
          <span class="rotulo">Vira Sumido depois de</span>
          <span class="entrada" [class.invalido]="errosPorCampo.diasSumido"><input type="number" min="8" step="1" [(ngModel)]="form.diasSumido" name="diasSumido"><em>dias</em></span>
          <span class="erro-campo" *ngIf="errosPorCampo.diasSumido">{{ errosPorCampo.diasSumido }}</span>
        </label>
        <label class="campo">
          <span class="rotulo">Vira Perdido depois de</span>
          <span class="entrada" [class.invalido]="errosPorCampo.diasPerdido"><input type="number" min="9" step="1" [(ngModel)]="form.diasPerdido" name="diasPerdido"><em>dias</em></span>
          <span class="erro-campo" *ngIf="errosPorCampo.diasPerdido">{{ errosPorCampo.diasPerdido }}</span>
        </label>
      </div>
      <span class="dica solta">Esfriando não tem número fixo: vale o ritmo de cada cliente. Quem pede toda semana esfria antes de quem pede uma vez por mês.</span>
    </div>

    <div class="grupo">
      <div class="grupo-titulo">Como fica cada segmento</div>
      <ul class="previa">
        <li *ngFor="let s of segmentos" [style.--cor]="s.cor">
          <span class="ponto"></span>
          <div>
            <strong>{{ s.nome }}</strong>
            <p>{{ regraDo(s.codigo) }}</p>
          </div>
        </li>
      </ul>
    </div>

    <div class="mensagem erro" *ngIf="erro"><i class="fe-alert-circle"></i>{{ erro }}</div>
    <div class="mensagem aviso" *ngIf="aviso && !erro"><i class="fe-check"></i>{{ aviso }}</div>
  </div>

  <footer class="painel-rodape">
    <button type="button" class="btn-secundario" (click)="recalcule()" [disabled]="salvando">
      <i class="fe-rotate-cw"></i> Recalcular agora
    </button>
    <button type="button" class="btn-primario" (click)="salve()" [disabled]="salvando || !!erroValidacao">
      {{ salvando ? 'Salvando…' : 'Salvar e reclassificar' }}
    </button>
  </footer>
</aside>
